import { useIntl } from 'react-intl';
import { Box, Typography } from '@packages/shared';
import { useRouter } from 'next/router';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { voucherPriceMessages } from './messages';
import { extractQueryParameter } from '../../helpers/extractQueryParameter';
import { useFormatedPrice } from '../../hooks/useFormatedPrice/useFormatedPrice';

const VoucherPriceFragment = graphql(/* GraphQL */ `
  fragment VoucherPriceFragment on ProductPrice {
    currency
    value
  }
`);

export type VoucherPriceProps = {
  priceData: FragmentType<typeof VoucherPriceFragment>;
};

/**
 * <p>This component renders a voucher price, also called "Geizhals Einsprung".</p>
 * */
export const VoucherPrice = ({ priceData }: VoucherPriceProps) => {
  const { value, currency } = getFragmentData(VoucherPriceFragment, priceData);
  const { query } = useRouter();
  const { voucherPriceDiscount } = extractQueryParameter(query);
  const { formatMessage } = useIntl();
  const formatPrice = useFormatedPrice('PRODUCT');

  if (!voucherPriceDiscount) {
    return null;
  }

  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          color: 'sale.main',
          fontWeight: 'fontWeightBold',
        }}
      >
        {formatMessage(voucherPriceMessages.DiscountPriceText, {
          price: formatPrice((value * ((100 - voucherPriceDiscount) / 100)) / 100, currency),
        })}
      </Typography>
      <Typography
        sx={{
          typography: 'body3',
          color: 'text.darkTransparent',
        }}
      >
        {formatMessage(voucherPriceMessages.DiscountSubtext)}
      </Typography>
    </Box>
  );
};
